import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "text-start" };
const _hoisted_2 = { class: "text-start" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("tr", null, [
        _createElementVNode("td", _hoisted_1, _toDisplayString(_ctx.resource.id), 1),
        _createElementVNode("td", _hoisted_2, _toDisplayString(_ctx.resource.name), 1)
    ]));
}
